import {
  Box,
  Divider,
  IconButton,
  InputAdornment,
  MenuItem,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import { allIcons } from "../../assets";
import appcolors from "../../constants/Colors";
import GlobalButton from "../CustomButton";
import { useNavigate } from "react-router-dom";
import CustomRangePicker from "../DateRangePicker";
import BranchMenu from "../MenuDropDown/BranchMenu";
import TeamMenu from "../MenuDropDown/TeamMenu";
import CustomDropDown from "../CutomDropDown";
import { MaximizeTwoTone } from "@mui/icons-material";
import { t } from "i18next";

const style = {
  muiTextField: {
    "& .MuiOutlinedInput-root": {
      borderRadius: 2,
      "& .MuiOutlinedInput-notchedOutline": {
        border: `1px solid #A6A9AC`,
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        border: `1px solid #A6A9AC`,
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        border: `1px solid #A6A9AC`,
      },
    },
  },
};

function AppContainer({
  headProps,
  children,
  primaryHeading,
  secondaryHeading,
  searchValue,
  onChange,
  showSerach,
  showFilterBtn,
  handleFilterData,
  showBackButton,
  handleBack,
  childrenProps,
  showCalenderIcon,
  handleFilterByDate,
  showRangerPicker,
  customIcom,
  showBranchesMenu,
  showTeamMenu,
  showCategory,
  searchMenuProps,
  serchPlaceHolder,
}) {
  return (
    <Paper sx={{ borderRadius: "6px" }}>
      <Stack
        p={2}
        sx={{
          flexDirection: { xs: "column", sm: "row" },
          alignItems: { sm: "center" },
          gap: { xs: 1.5, sm: 0 },
        }}
      >
        <Stack gap={2} direction={"row"} alignItems={"center"} flex={1}>
          {showBackButton ? (
            <IconButton
              onClick={handleBack}
              disableRipple
              sx={{
                padding: 0,
                "&:hover": {
                  backgroundColor: "transparent",
                },
              }}
            >
              <img
                src={allIcons.backIcon}
                alt={"card-icon"}
                width={25}
                height={25}
              />
            </IconButton>
          ) : customIcom ? (
            customIcom
          ) : (
            <img
              src={allIcons.cardIcon}
              alt={"back-icon"}
              width={30}
              height={30}
            />
          )}
          <Box>
            <Typography
              variant={"body1"}
              fontWeight={600}
              lineHeight={"normal"}
              textTransform={"capitalize"}
            >
              {primaryHeading}
            </Typography>
            <Typography
              variant={"body2"}
              fontSize={"0.8rem"}
              color={appcolors.crayolaGrey}
            >
              {secondaryHeading}
            </Typography>
          </Box>
        </Stack>
        {headProps && headProps}
      </Stack>
      <Divider />
      {showSerach && (
        <Stack
          gap={1.5}
          direction={"row"}
          p={"8px 16px"}
          bgcolor={appcolors.primaryLight}
        >
          <TextField
            sx={style.muiTextField}
            placeholder={serchPlaceHolder || t("searchName")}
            variant="outlined"
            value={searchValue}
            onChange={onChange}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start" sx={{ cursor: "pointer" }}>
                  <img src={allIcons.searchIcon} alt="search-icon" width={25} />
                </InputAdornment>
              ),
            }}
          />
          {showSerach && showRangerPicker && (
            <CustomRangePicker
              stackProps={{
                boxShadow: "rgba(0, 0, 0, 0.09) 0px 3px 12px",
                borderRadius: "6px",
              }}
            />
          )}
          {showSerach && showFilterBtn && (
            <Box height={40}>
              <GlobalButton
                variant={"contained"}
                btnText={"Filter"}
                startIcon={
                  <img src={allIcons.filterIcon} alt="filter-icon" width={20} />
                }
                styleProps={{
                  fontWeight: 400,
                  fontSize: "0.875rem",
                }}
                handleClickBtn={handleFilterData}
              />
            </Box>
          )}
          {showSerach && showCalenderIcon && (
            <IconButton
              onClick={handleFilterByDate}
              sx={{
                padding: "2px",
                "&:hover": { backgroundColor: "transparent" },
              }}
            >
              <img
                src={allIcons.calendarGreyIcon}
                alt="calendar-icon"
                width={25}
              />
            </IconButton>
          )}
          {showSerach && showCategory && (
            <CustomDropDown
              icon={
                <img src={allIcons.statusIcon} alt="Status-icon" width={20} />
              }
              value={"Category"}
              displayEmpty
              onClick={handleFilterByDate}
              sx={{
                maxHeight: 47,
                maxWidth: "160px",
                "& .MuiOutlinedInput-notchedOutline": {
                  border: "none !important",
                },
                "& .MuiSelect-select:focus": {
                  backgroundColor: "transparent",
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  border: "none !important",
                },
              }}
            >
              <MenuItem value="Category">Category</MenuItem>
              <MenuItem value="Category1">Category 1</MenuItem>
              <MenuItem value="Category2">Category 2</MenuItem>
            </CustomDropDown>
          )}
          <Stack direction={"row"} alignItems={"center"} gap={2}>
            {showBranchesMenu && <BranchMenu />}
            {showTeamMenu && <TeamMenu />}
          </Stack>
          {searchMenuProps}
        </Stack>
      )}
      <Box p={"12px 16px"} {...childrenProps}>
        {children}
      </Box>
    </Paper>
  );
}

export default AppContainer;
